import React from 'react';
import CompareTooltip from './CompareTooltip';

function AGGridLinkCellRenderer({value, data}) {
	if (value && value.clickable) {
		return (
			<CompareTooltip
				data={data}
				value={value}
				renderer={
					<section className="trigger-link">
						<section className="link">{value.clickable}</section>
						{value.label && <section className="link-label">{value.label}</section>}
					</section>
				}
			/>
		);
	}

	return null;
}

export default AGGridLinkCellRenderer;
